import {ISelectItem} from '../../drop-down';

export const PMP_PAYMENT_TYPE_REFERRAL = 'referral';
export const PMP_PAYMENT_TYPE_SCREENING = 'screening';
export const PMP_PAYMENT_TYPE_SCHEDULING = 'schedulingAndPreSessionPreperation';
export const PMP_PAYMENT_TYPE_MEDIATION = 'mediationAndSessionDebrief';
export const PMP_PAYMENT_TYPE_PARTICIPANT_EVAL = 'participantEvaluation';
export const PMP_PAYMENT_TYPE_TELEPHONE_INTERVIEW = 'telephoneInterview';
export const PMP_PAYMENT_TYPE_POST_SESSION = 'postSession';

export type IPmpPaymentStatus = 'Pending' | 'Submitted' | 'Approved';

export type PmpPaymentType =
    | 'referral'
    | 'screening'
    | 'schedulingAndPreSessionPreperation'
    | 'mediationAndSessionDebrief'
    | 'participantEvaluation'
    | 'telephoneInterview'
    | 'postSession';

export interface IPmpPayment {
    _id: string; // generate

    rate: number;
    title: string;
    status: IPmpPaymentStatus;

    /**
     *
     */
    durationOrCount: number;

    /**
     * Generate total value
     */
    value?: number;

    /**
     * Date that take into invoice calculations
     */
    date: Date;

    /**
     * Scheduling & Pre-Session Preparation and
     * Mediation & Session Debrief
     * have display dates other than the above date
     */
    displayDate?: Date;

    // /**
    //  * Date submited the MOPC
    //  */
    // dateSubmited?: Date;

    // /**
    //  * Approved by MOPC
    //  */
    // dateApproved?: Date;

    actionId?: string;

    /**
     *
     */
    invoiceId?: string;

    // Need to show in telephone interviews
    cp?: string;
    ncp?: string;
    completedInterviews?: boolean;
}

export interface IPayment {
    _id?: string;
    action?: ISelectItem;
    systemGenerated?: boolean;
    date?: Date;
    title: ISelectItem;
    amount?: number;
    status?: ISelectItem;
    description?: string;
    comment?: string;
    contributionType?: ISelectItem;
    rate: number;
    rateType?: ISelectItem;
    duration?: number;
    subTotal?: number;
    reductionType?: ISelectItem;
    reductionAmount?: number;
    total?: number;
    reductionRemark?: string;
    paymentToType?: ISelectItem;
    paymentTo?: string;
    paymentByType?: ISelectItem;
    paymentBy?: string;
    // paymenet out
    paymentOut?: boolean;
}

export interface IPaymentCreated extends IPayment {
    id: string;
}
